export const ETAPAS_RH = [
  {
    id: "pessoal",
    titulo: "Informações Pessoais",
    subtitulo: "Dados básicos, foto e líder imediato",
    icone: "mdi-account-outline",
  },
  {
    id: "documentacao",
    titulo: "Documentação e Contato",
    subtitulo: "CPF, RG, CTPS, e-mail e telefone",
    icone: "mdi-card-account-details-outline",
  },
  {
    id: "endereco",
    titulo: "Endereço Residencial",
    subtitulo: "CEP, logradouro e complemento",
    icone: "mdi-map-marker",
  },
  {
    id: "contratos",
    titulo: "Contratos e Vínculos",
    subtitulo: "Matrícula, cargos, lotação e jornada",
    icone: "mdi-briefcase",
  },
  {
    id: "formacao",
    titulo: "Formação Acadêmica",
    subtitulo: "Escolaridade e cursos concluídos",
    icone: "mdi-school",
  },
  {
    id: "anexos",
    titulo: "Anexos e Documentação",
    subtitulo: "Todos os arquivos do colaborador",
    icone: "mdi-file-document-multiple-outline",
  },
  {
    id: "escalas",
    titulo: "Escalas de Trabalho",
    subtitulo: "Jornada semanal e vigência",
    icone: "mdi-calendar-clock",
  },
  {
    id: "revisao",
    titulo: "Revisão e Envio",
    subtitulo: "Confira as informações antes de salvar",
    icone: "mdi-check-circle-outline",
  },
];

// Os ids precisam ser os mesmos aceitos pela API em
// RecursosHumanosController::CATEGORIAS_DOCUMENTO.
export const CATEGORIAS_DOCUMENTO = [
  { id: "pessoais", titulo: "Documentos pessoais", icone: "mdi-account-outline" },
  {
    id: "documentacao",
    titulo: "Documentos de identificação",
    icone: "mdi-card-account-details-outline",
  },
  { id: "endereco", titulo: "Comprovante de residência", icone: "mdi-map-marker" },
  { id: "contratos", titulo: "Documentos contratuais", icone: "mdi-briefcase" },
  { id: "formacao", titulo: "Diplomas e certificados", icone: "mdi-school" },
  { id: "geral", titulo: "Outros documentos", icone: "mdi-paperclip" },
];

export function tituloCategoriaDocumento(id) {
  const categoria = CATEGORIAS_DOCUMENTO.find((item) => item.id === id);
  return categoria ? categoria.titulo : "Outros documentos";
}

export function novoProfissional() {
  return {
    matricula: "",
    regime_trabalhista: "",
    cargo_concurso: "",
    cargo_exercicio: "",
    franquias_permitidas: [],
    data_ingresso: "",
    ch_total: "",
    ctps: "",
    serie: "",
    turno: [],
  };
}

export function novaFormacao() {
  return {
    instituicao: "",
    area_do_curso: "",
    curso: "",
    ano_conclusao: "",
  };
}

const DIAS_ABREVIADOS = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];

export function resumoDiasTrabalhados(escala) {
  const dias = (escala.horarios || [])
    .filter((h) => h.trabalha)
    .map((h) => DIAS_ABREVIADOS[h.dia_semana]);
  return dias.length ? dias.join(", ") : "Sem dias de trabalho";
}

// A API grava o arquivo como "<categoria>__<uuid>"; arquivos anteriores ao
// cadastro por etapas não têm prefixo e entram em "geral".
export function categoriaDoArquivo(nomeArquivo) {
  const [prefixo] = String(nomeArquivo || "").split("__");
  const valida = CATEGORIAS_DOCUMENTO.some((item) => item.id === prefixo);
  return valida && String(nomeArquivo).includes("__") ? prefixo : "geral";
}

// Envios novos terminam em "<uuid>__<nome original>"; os antigos não têm o nome.
export function nomeOriginalDoArquivo(nomeArquivo) {
  const encontrado = String(nomeArquivo || "").match(
    /[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}__(.+)$/i
  );
  return encontrado ? encontrado[1] : "";
}

// A coluna "documento" pode chegar como array, como JSON (às vezes codificado
// duas vezes pela API) ou como lista separada por vírgula.
export function normalizarDocumentos(valor) {
  let atual = valor;
  for (let tentativa = 0; tentativa < 3 && typeof atual === "string"; tentativa += 1) {
    try {
      atual = JSON.parse(atual);
    } catch (e) {
      atual = atual.split(",");
    }
  }
  if (Array.isArray(atual)) {
    return atual.filter((item) => typeof item === "string" && item);
  }
  return [];
}
